import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { authService } from '../../services/authService';
import { Alert, Container, Card, Spinner } from 'react-bootstrap';

const VerifyEmail = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const verify = async () => {
      try {
        const response = await authService.verifyEmail(token);
        setStatus('success');
        setMessage(response.message);
        setTimeout(() => navigate('/login'), 3000);
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Verification failed');
      }
    };
    if (token) verify();
  }, [token, navigate]);

  return (
    <Container className="mt-5">
      <Card className="mx-auto" style={{ maxWidth: '500px' }}>
        <Card.Body className="text-center">
          <h2 className="mb-4">Email Verification</h2>
          {status === 'verifying' && <><Spinner animation="border" /><p className="mt-3">Verifying your email...</p></>}
          {status === 'success' && <Alert variant="success">{message}</Alert>}
          {status === 'error' && <Alert variant="danger">{message}</Alert>}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default VerifyEmail;